<template>
  <v-container>
    <v-row>
      <preview
        id="preview-schedule"
        ref="preview"
        :is-preview="true"
        :schedule-manager="scheduleManager"
        :show="showPreview"
      />
    </v-row>
    <v-row id="textRenderingToCanvas" />
  </v-container>
</template>

<script>
// Components
import preview from "./Player/Preview";

// Connectors
import { PlayerConnector } from "./Database/PlayerConnector";
import { ScheduleConnector } from "./Database/ScheduleConnector";

// Controllers
import { ScheduleFileMaker } from "./SchedulePage/ScheduleFileMaker";
import { ScheduleManager } from "./SchedulePage/ScheduleManager";
import { ScheduleReader } from "./SchedulePage/ScheduleReader";

// Tools
const sqlTool = require("./Tools/SQLTools");

export default {
  components: {
    preview,
  },
  props: {
    license: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      scheduleConnector: new ScheduleConnector(this.$store.state.user),
      playerConnector: new PlayerConnector(this.$store.state.user),
      players: [],
      scheduleManager: null,
      showPreview: false,
    };
  },
  mounted() {
    this.playerConnector
      .getInfo(this.license)
      .then((response) => {
        if (response.length > 0) {
          const result = response[0];

          this.scheduleConnector.socId = result.soc_id;
          this.players = [result.id_plyr];
          this.preview();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  },
  methods: {
    preview() {
      // Collect all schedules to display
      const schedulesReader = [];
      // Hide preview to reset previous projects
      this.showPreview = false;

      this.scheduleConnector
        .collectScheduleForPlayers(this.players)
        .then((schedules) => {
          schedules.forEach(async (schedule) => {
            schedulesReader.push(
              new ScheduleReader(
                await sqlTool.convertScheduleSQLToJS(schedule),
                "./" + schedule.path,
                this.$store.state.user,
                true
              )
            );
          });

          this.scheduleManager = new ScheduleManager(schedulesReader, null, true, false, this.$store.state.user);

          const schedulefileMaker = new ScheduleFileMaker();
          schedulefileMaker
            .init(this.scheduleManager, "preview", "preview", this.$store.state.user, true)
            .then((fileMaker) => {
              fileMaker
                .make()
                .then(() => {
                  this.scheduleManager
                    .load()
                    .then(() => {
                      this.showPreview = true;
                    })
                    .catch((err) => {
                      console.error(err);
                    });
                })
                .catch((err) => {
                  console.error(err);
                });
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style>
/**
    Text rendering container
  */
#textRenderingToCanvas {
  position: absolute;
  top: -9999px;
  left: -9999px;

  background-color: transparent;
  font-size: 400%;
  white-space: nowrap;
  word-wrap: none;
  opacity: 0;
}

/** 
    Player container
  */
#preview-schedule #playerContainer {
  width: 75vw;
  height: 75vh;
}
</style>
